import qs from "qs";
import axios from "axios";
import { API_URL } from "../../../../constants/Constants";

/**
 * Obtiene las referencias que no tienen imágenes JPG asociadas
 * @returns {Promise<Array|false>} Lista de referencias sin imágenes o false si hay error
 */
export const getReferenciasSinImagenes = async () => {
  const queryData = {
    screen: "articles",
    action: "get_jpg_images",
  };

  try {
    const response = await axios.post(API_URL, qs.stringify(queryData));

    let responseData = response.data;

    // Manejar respuesta que puede venir como string JSON
    if (typeof responseData === 'string' && responseData.includes('{')) {
      try {
        const jsonStart = responseData.indexOf('{');
        const jsonString = responseData.substring(jsonStart);
        responseData = JSON.parse(jsonString);
      } catch (parseError) {
        console.error("Error al parsear JSON de la respuesta:", parseError);
        return false;
      }
    }

    if (responseData.status === "ok" || responseData.status === "success" || responseData.status === "Success") {
      return responseData.data || responseData;
    } else {
      console.error("Error al obtener referencias sin imágenes:", responseData.message);
      return false;
    }
  } catch (error) {
    console.error("Error al obtener referencias sin imágenes:", error);
    return false;
  }
};

